import {Swiper} from 'swiper'
import { loadElementLazyImage } from '../helpers/lazy-load'
import { updateSmoothScroll } from '../scroll-smoother'

// media and content slider
let participationsSlider = $('.js-participations-block')
if (participationsSlider.length){

  participationsSlider.each((i, block)=> {

    let slider = $(block).find('.js-slider')
    let nextB = $(block).find('.js-next-slide')
    let prevB = $(block).find('.js-prev-slide')
    let catB = $(block).find('.js-cat-b')
    let posts = slider.find('.post-el')
    let sliderWrapper = slider.find('.swiper-wrapper')
    let swiper

    let swiperParams = {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      breakpoints: {
        1800: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
        900: {
          slidesPerView: 3,
        },
        700: {
          slidesPerView: 2,
        },
      },
      // autoplay: {
      //   delay: 4000,
      // },
      // speed: 400
    }


    // Slider
    function initSlider(initSlider){
      swiper = new Swiper(initSlider, swiperParams);

      // navigation buttons
      nextB.click(()=> swiper.slideNext() )
      prevB.click(()=> swiper.slidePrev() )

      // slide change event
      swiper.on('slideChange', (slider)=> {
        disableNavButtons(slider)
      });

    }

    function disableNavButtons(slider){
      slider.isEnd ? nextB.addClass('disabled') : nextB.removeClass('disabled')
      slider.isBeginning ? prevB.addClass('disabled') : prevB.removeClass('disabled')
    }

    initSlider(slider[0])



    // filter
    catB.click(function() {
      let id = $(this).data('term-id')

      // if ($(this).hasClass('active')){
      //   id = 0
      //   catB.removeClass('active')
      // } else {
        catB.removeClass('active')
        catB.filter( (i, b) => {
          return $(b).data('term-id') === id
        }).addClass('active')
      //}

      swiper.destroy()
      sliderWrapper.empty()

      posts.each((i,p)=>{
        let termIdString = $(p).data('term-id')
        let postIds = termIdString.toString().split(',')
        let add = 0
        $(postIds).each((i, e)=> {
          if (parseInt(e) === parseInt(id) ) add = 1
        })

        if (add || id === 0 || termIdString === 0) sliderWrapper.append($(p).parent())
      })

      initSlider(slider[0])

      updateSmoothScroll()
      loadElementLazyImage($(block).find('.lazy'))
    })

    $(block).find('.js-cat-b.active').first().click()


  })

}
